import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/icon_status_-1@3x.png'


const _hoisted_1 = { class: "p-ml-3 p-mr-3 p-mt-3" }
const _hoisted_2 = { class: "p-p-3 shadow bg-color-secondary rounded" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "100",
    src: _imports_0
  })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "p-text-center"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, " หากท่านต้องการแจ้งปัญหา ท่านสามารถติดต่อพนักงานขายของท่าน หรือติดต่อส่วนกลางผ่านช่องทางดังนี้ ", -1)
const _hoisted_7 = { class: "p-mt-2" }
const _hoisted_8 = { class: "p-mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionCompleteHeader = _resolveComponent("TransactionCompleteHeader")!
  const _component_TransactionCartDetail = _resolveComponent("TransactionCartDetail")!
  const _component_TransactionAddressDetails = _resolveComponent("TransactionAddressDetails")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_TransactionCompleteHeader, {
        transactionInvoice: _ctx.transaction.invoiceNo,
        statusId: _ctx.transaction.statusId,
        statusName: _ctx.transaction.statusName
      }, null, 8, ["transactionInvoice", "statusId", "statusName"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _hoisted_3,
          (_ctx.transaction.shippingTypeId !== 7)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, " ขณะนี้รายการสั่งซื้อของคุณกำลังถูกจัดเตรียมสินค้า อยู่ที่คลังสินค้า กรุณารอสินค้าประมาณ 1-3 วันทำการ "))
            : (_openBlock(), _createElementBlock("p", _hoisted_5, " ตรงนั้นเปลี่ยนเป็น ขณะนี้รายการสั่งซื้อของคุณกำลังถูกจัดเตรียม ที่ " + _toDisplayString(_ctx.transaction.SelfPickingLocation) + " กรุณารอสักครู่เพื่อให้แอดมินตรวจสอบสินค้า ", 1)),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_TransactionCartDetail, {
          transaction: _ctx.transaction,
          isShowCart: true
        }, null, 8, ["transaction"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_TransactionAddressDetails, {
          buyerInfo: _ctx.transaction.buyerInfo,
          isDisplayAddress: true
        }, null, 8, ["buyerInfo"])
      ])
    ])
  ]))
}